import { v4 as uuidv4 } from "uuid";

import { getOrderedElements } from "./contentUtils";

const createHighlight = (items) => {
  return {
    begin: uuidv4(),
    end: uuidv4(),
    items,
  };
};

const getHighlightPosition =
  (content) =>
  (highlights = []) =>
  (highlight) => {
    if (!highlights.length) {
      return 0;
    } else {
      const tagUUIDs = getOrderedElements(content)(`mark`).map((el) =>
        el.getAttribute("data-uuid"),
      );
      const tagUUIDsNoEnds = tagUUIDs.filter(
        (id) => !highlights.map((hl) => hl?.end).includes(id),
      );
      return tagUUIDsNoEnds.findIndex(
        (id) =>
          highlight[
            highlight?.__typename === "ItemPointReference" ? "point" : "begin"
          ] === id,
      );
    }
  };

export { createHighlight, getHighlightPosition };
